module.exports = __webpack_public_path__ + "img/sensor_down_selected.f1d6ca80.svg";